import React from 'react';
import { AccountType } from 'further-types/investor';
import Spacing from 'components/Spacing';
import RecordRow from 'components/RecordRow';
import { ApiResponses } from 'lib/trpcClient';
import { IncomeSourceLabels } from 'further-ui/labels';

type GetInvestorResponse = ApiResponses['investor']['getInvestor'];

type InvestorDetails = Pick<
  GetInvestorResponse,
  | 'isClaimingTax'
  | 'primaryTaxId'
  | 'secondaryTaxId'
  | 'taxResidencies'
  | 'registeredTaxNumber'
  | 'accountType'
  | 'incomeSources'
>;

type Props = {
  bankDetails?: GetInvestorResponse['bankDetails'];
  investorDetails: InvestorDetails;
};

const TaxAndBankDetails: React.FC<Props> = ({
  bankDetails,
  investorDetails,
}) => {
  return (
    <Spacing size="sm">
      <RecordRow label="Bank account name">
        {bankDetails?.bankAccountName ?? '-'}
      </RecordRow>
      <RecordRow label="Bank name">{bankDetails?.bankName ?? '-'}</RecordRow>
      <RecordRow label="Bank sort code">
        {bankDetails?.bankSortCode ?? '-'}
      </RecordRow>
      <RecordRow label="Bank account number">
        {bankDetails?.bankAccountNumber ?? '-'}
      </RecordRow>
      <RecordRow label="IBAN/non-UK account number">
        {bankDetails?.iban ?? '-'}
      </RecordRow>
      <RecordRow label="SWIFT/BIC">{bankDetails?.swift ?? '-'}</RecordRow>
      <RecordRow label="ABA/ACH/International code">
        {bankDetails?.internationalBankCode ?? '-'}
      </RecordRow>

      {investorDetails.accountType === AccountType.LegalEntity ? (
        <RecordRow label="Registered tax number">
          {investorDetails?.registeredTaxNumber ?? '-'}
        </RecordRow>
      ) : (
        <>
          <RecordRow label="Primary tax ID">
            {investorDetails?.primaryTaxId ?? '-'}
          </RecordRow>
          <RecordRow label="Secondary tax ID">
            {investorDetails?.secondaryTaxId ?? '-'}
          </RecordRow>
        </>
      )}
      <RecordRow label="Tax domicile/residency">
        {investorDetails?.taxResidencies?.length
          ? investorDetails.taxResidencies.map(({ country }) => {
              return <div key={country}>{country}</div>;
            })
          : '-'}
      </RecordRow>
      <RecordRow label="Claiming tax relief">
        {investorDetails?.isClaimingTax === true
          ? 'Yes'
          : investorDetails?.isClaimingTax === false
          ? 'No'
          : '-'}
      </RecordRow>
      <RecordRow label="US person?">
        {bankDetails?.isUsPerson ? 'Yes' : 'No'}
      </RecordRow>
      {investorDetails.accountType === AccountType.Individual && (
        <RecordRow label="Source of funds">
          {investorDetails?.incomeSources?.length
            ? investorDetails.incomeSources.map((source) => {
                return (
                  <div key={source}>{IncomeSourceLabels[source] ?? source}</div>
                );
              })
            : '-'}
        </RecordRow>
      )}
    </Spacing>
  );
};

export default TaxAndBankDetails;
